<template>
  <div class="columns">
    <div class="column">
      <b-field :label="$t('common.image')">
        <b-field v-if="isEditMode" class="file is-primary" :class="{'has-name': !!imageFile}">
          <b-upload v-model="imageFile" class="file-label" accept=".jpg, .jpeg, .png"
                    @input="onImageFileSelected">
            <span class="file-cta">
              <b-icon class="file-icon" icon="upload"></b-icon>
              <span class="file-label">{{ $t('user-details-view.select-image-button') }}</span>
            </span>
            <span class="m-2" v-if="!imageFile">{{ $t('user-details-view.image-allowed-size') }}</span>
            <span class="file-name" v-if="imageFile">
              {{ imageFile.name }}
            </span>
          </b-upload>
          <b-button v-if="isImageFileSelected" class="button is-primary is-danger" icon-left="delete"
                    @click="onImageFileRemoveSelected"></b-button>
        </b-field>
      </b-field>
      <div class="column is-half" v-if="isImageUrlLoaded">
        <b-image :src=imageUrl class="image">
        </b-image>
      </div>
      <div class="column is-half" v-if="!isImageUrlLoaded">
        <b-image :src="require('@/assets/placeholder.png')" class="image"></b-image>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ImagePicker",
  props: {
    'isEditMode': {
      type: Boolean,
    },
    'imageUrl': {
      type: String
    }
  },
  data() {
    return {
      imageFile: null
    }
  },
  methods: {
    onImageFileSelected() {
      this.imageUrl = URL.createObjectURL(this.imageFile)
      console.log("Selected image file: ", URL.createObjectURL(this.imageFile))
      this.$emit("onImageFileSelected", this.imageFile)
    },
    onImageFileRemoveSelected() {
      this.imageFile = null
      this.$emit("onImageFileRemoveSelected")
    }
  },
  computed: {
    isImageFileSelected() {
      return this.imageFile !== null && this.imageFile !== undefined && this.imageFile !== "";
    },
    isImageUrlLoaded() {
      return this.imageUrl !== null && this.imageUrl !== undefined && this.imageUrl !== "";
    }
  },
  watch: {
    imageUrl: function () {
      if (this.imageUrl === null || this.imageUrl === undefined || this.imageUrl === "") {
        this.imageFile = null
      }
    }
  }
}
</script>